/* the matcha koncept — theme JS */

(() => {
  'use strict';

  // Mobile menu toggle
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const navScrim = document.querySelector('[data-nav-scrim]');
  const setMenu = (open) => {
    mobileMenu?.classList.toggle('is-open', open);
    navScrim?.classList.toggle('is-open', open);
    menuToggle?.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('no-scroll', open);
  };
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      setMenu(!mobileMenu.classList.contains('is-open'));
    });
  }
  navScrim?.addEventListener('click', () => setMenu(false));

  // Quantity input + / - buttons
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input[type="number"], input[name="quantity"]');
    if (!input) return;
    wrap.querySelectorAll('[data-qty-step]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const step = parseInt(btn.getAttribute('data-qty-step'), 10) || 1;
        const min = parseInt(input.getAttribute('min'), 10) || 1;
        const max = parseInt(input.getAttribute('max'), 10) || 999;
        const next = Math.max(min, Math.min(max, (parseInt(input.value, 10) || 1) + step));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Variant picker — sync form input + price display (text-only, no HTML)
  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    const idInput = picker.querySelector('input[name="id"]');
    const priceEl = document.querySelector('[data-product-price]');
    const buyBtn = document.querySelector('[data-add-to-cart]');

    picker.querySelectorAll('[data-variant]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        picker.querySelectorAll('[data-variant]').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        const variantId = btn.getAttribute('data-variant');
        const variantPrice = btn.getAttribute('data-variant-price');
        const variantAvailable = btn.getAttribute('data-variant-available') === 'true';

        if (idInput) idInput.value = variantId;
        if (priceEl && variantPrice) priceEl.textContent = variantPrice;
        if (buyBtn) {
          buyBtn.disabled = !variantAvailable;
          buyBtn.textContent = variantAvailable
            ? buyBtn.getAttribute('data-label-add')
            : buyBtn.getAttribute('data-label-soldout');
        }
      });
    });
  });

  // Inline expanding search in header
  const navSearch = document.querySelector('[data-nav-search]');
  const navSearchToggle = document.querySelector('[data-nav-search-toggle]');
  const navSearchInput = document.querySelector('[data-nav-search-input]');
  if (navSearch && navSearchToggle && navSearchInput) {
    const closeNavSearch = () => {
      navSearch.classList.remove('is-open');
      navSearchInput.value = '';
      navSearchInput.blur();
    };
    const openNavSearch = () => {
      navSearch.classList.add('is-open');
      setTimeout(() => navSearchInput.focus(), 80);
    };

    navSearchToggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (navSearch.classList.contains('is-open')) closeNavSearch();
      else openNavSearch();
    });

    // Click anywhere outside the search closes it
    document.addEventListener('click', (e) => {
      if (navSearch.classList.contains('is-open') && !navSearch.contains(e.target)) {
        closeNavSearch();
      }
    });

    // Escape closes
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && navSearch.classList.contains('is-open')) {
        closeNavSearch();
      }
    });
  }

  // Reveal on scroll — with safety fallback so nothing stays invisible
  const revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -50px 0px' });
    revealEls.forEach((el) => io.observe(el));
    // Safety: if any element is still hidden after 4s, force-reveal it
    setTimeout(() => {
      revealEls.forEach((el) => {
        if (!el.classList.contains('is-revealed')) {
          el.classList.add('is-revealed');
          io.unobserve(el);
        }
      });
    }, 4000);
  } else {
    // No IO support → reveal everything immediately
    revealEls.forEach((el) => el.classList.add('is-revealed'));
  }
})();
